import { ISearchAreaOption, setClass, useStore } from '@utils';
import React, { FC } from 'react';
import { CalendarIcon } from '../../svgs';
import { CalendarColorsStore } from '../../../store';
import { Checkbox } from '../../checkbox';

export const SearchAreaOption: FC = (option: ISearchAreaOption, isSelected: boolean,) => {
  const calendarColorsStore = useStore(CalendarColorsStore);
  return (
    <div className="calendar">
      {typeof option.data !== 'string'
        ? <Checkbox
          value={isSelected}
          label={option.data.title}
          color={calendarColorsStore.getColorByName(option.data.calendarColor)?.hexCode}
        />
        : <>
          <CalendarIcon />
          <p className={setClass("title", isSelected && 'selected')}>{option.data}</p>
        </>
      }
    </div>
  );
};
